import {
  HTTP_REPORTMANAGERBYDEPTS_FETCHING,
  HTTP_REPORTMANAGERBYDEPTS_SUCCESS,
  HTTP_REPORTMANAGERBYDEPTS_FAILED,
} from "././../../Constants";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_REPORTMANAGERBYDEPTS_FETCHING:
      return {
        ...state,
        result: [],
        isFetching: true,
        isError: false,
      };
    case HTTP_REPORTMANAGERBYDEPTS_SUCCESS:
      return {
        ...state,
        result: payload,
        isFetching: false,
        isError: false,
      };
    case HTTP_REPORTMANAGERBYDEPTS_FAILED:
      return {
        ...state,
        result: [],
        isFetching: false,
        isError: true,
      };
    default:
      return state;
  }
};
